import { enc, MD5 } from "crypto-js";

export const md5Hash = (target: string): string => MD5(target).toString(enc.Hex);
